import List from './List';

export default List;



// WEBPACK FOOTER //
// ./src/components/CaseStudiesPage/components/List/index.js